"use strict";
/*
 * Created on 16.10.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var ManualPromoWeekSplitConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ManualPromoWeekSplitConverter, _DataObjectConverter_);

  function ManualPromoWeekSplitConverter() {
    _classCallCheck(this, ManualPromoWeekSplitConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ManualPromoWeekSplitConverter).apply(this, arguments));
  }

  return ManualPromoWeekSplitConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ManualPromoWeekSplitConverter = ManualPromoWeekSplitConverter;